import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import TrustForm from '../../../../components/TrustForm';
import FilingListGrid from '../../../../components/FilingListGrid';
import SalesPanel from '../../../../components/SalesPanel';
import SalesListGrid from '../../../../components/SalesListGrid';
import AdvancedSalesListGrid from '../../../../components/AdvancedSalesListGrid';
import HistoryGrid from '../../components/HistoryGrid';

import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';

import {
    updateTrustHistoryItemSelected,
    handleViewTrustVisibility,
    handleEditTrustVisibility,
    fetchTrustSales,
    fetchTrustAdminSales,
    fetchTrustFilings
} from '../../../../../../services/redux/employee/trust/actions';

import {
    fetchFilingById,
    updateFilingInfoData,
    fetchClientData,
    fetchStateData
} from '../../../../../../services/redux/employee/filing/actions';
class ViewTrust extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1
        };
    }
    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }
    onEditClick = () => {
        let {
            handleViewTrustVisibility,
            handleEditTrustVisibility
        } = this.props;
        handleViewTrustVisibility(false);
        handleEditTrustVisibility(true);
    };

    onBackClick = () => {
        let { handleViewTrustVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleViewTrustVisibility(false);
        }
    };

    onViewSalesClick = (startDate, endDate, state = '') => {
        let { trust, fetchTrustSales } = this.props;
        fetchTrustSales({
            trustId: trust.viewTrust.trustId,
            startDate,
            endDate,
            state
        });
    };

    onViewAdvancedSalesClick = (startDate, endDate, state = '') => {
        let { trust, fetchTrustAdminSales } = this.props;
        fetchTrustAdminSales({
            trustId: trust.viewTrust.trustId,
            startDate,
            endDate,
            state
        });
    };

    onChangeTab = key => {
        this.setState({ activeTab: key });
    };

    reviewPendingFiling = data => {
        let {
            history,
            trust,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(data.filingId).then(response => {
            if (response) {
                fetchClientData(response.clientId);
                fetchStateData(response.stateId);
            }
        });
        updateFilingInfoData({ ...data, trustName: trust.editTrust.name });

        history.push({ pathname: '/filing-details', from: '/client-details' });
    };

    render() {
        let {
            trust,
            commonData,
            clientInformation,
            roleName,
            updateTrustHistoryItemSelected
        } = this.props;
        let { activeTab } = this.state;

        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );
        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );
        return (
            <div className="panel">
                <Tabs
                    id="tabID"
                    onSelect={this.onChangeTab}
                    activeKey={this.state.activeTab}
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="View Trust">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <TrustForm
                                    trustData={trust.editTrust}
                                    clientList={clientInformation.clients}
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    isEditable={false}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Filings">
                        <FilingListGrid
                            dataList={trust.filings}
                            handleReviewButtonClick={this.reviewPendingFiling}
                        />
                    </Tab>
                    <Tab eventKey={3} title="Sales">
                        <SalesPanel
                            onViewClick={this.onViewSalesClick}
                            stateList={commonData.states}
                        />
                        <SalesListGrid dataList={trust.sales} />
                    </Tab>
                    {(roleName === 'Administrator' ||
                        roleName === 'Superuser') && (
                        <Tab eventKey={4} title="Advanced Sales">
                            <SalesPanel
                                onViewClick={this.onViewAdvancedSalesClick}
                                stateList={commonData.states}
                            />
                            <AdvancedSalesListGrid
                                dataList={trust.adminSales}
                            />
                        </Tab>
                    )}
                    <Tab eventKey={5} title="Change Log">
                        <HistoryGrid
                            dataList={trust.history}
                            updateSelected={updateTrustHistoryItemSelected}
                        />
                        {trust.selectedHistoryItem &&
                            trust.selectedHistoryItem.trustId && (
                                <Panel
                                    showHeader
                                    header="History Item Details"
                                    panelStyle="panel-default m0"
                                >
                                    <div className="col-lg-6 col-md-8 col-sm-12">
                                        <TrustForm
                                            trustData={
                                                trust.selectedHistoryItem
                                            }
                                            parentClients={trust.parentClients}
                                            countryList={commonData.countries}
                                            stateList={commonData.states}
                                            isEditable={false}
                                        />
                                    </div>
                                </Panel>
                            )}
                    </Tab>
                    <br />
                    {activeTab === 1 && editButton}
                    {backButton}
                </Tabs>
                {trust.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    trust: state.employee.trust,
    commonData: state.commonData,
    clientInformation: state.employee.clientInformation,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            updateTrustHistoryItemSelected,
            handleViewTrustVisibility,
            handleEditTrustVisibility,
            fetchTrustSales,
            fetchTrustAdminSales,
            fetchTrustFilings,
            fetchFilingById,
            updateFilingInfoData,
            fetchClientData,
            fetchStateData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewTrust));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/ViewTrust/index.js